import useGetCategories from './useGetCategories'

export default useGetCategories
